import classNames from "classnames";
import { AppointmentPhase } from "components";
import { AppointmentSidePanel } from "components/SidePanel/Appointment/AppointmentSidePanel";
import React from "react";

interface CalendarAppointmentProps {
  appointment: server.dto.AppointmentForPlanner;
  isHovered: boolean;
  onHover: (id: number | null) => void;
}

const renderAppointmentBody = (appointment: server.dto.AppointmentForPlanner) => <>
  {appointment.startedBeforeCurrentPeriod && <div className="flex-column justify-center">
    <i className="icon small icon-back" />
  </div>}
  <div
    style={{ backgroundColor: appointment.status.hexColor, display: appointment.status.statusId === 0 ? "none" : "block" }}
    className="calendar-appointment-status"
  />
  <div className="calendar-appointment-content">
    {appointment.lineArtist} <br />
    {appointment.line1} <br />
    {appointment.line2}
  </div>
  <div className="calendar-appointment-icons">
    <i className={classNames(appointment.type.icon)} />
    <AppointmentPhase value={appointment.phase} displayLabel={false} />
  </div>
</>

export const CalendarAppointment = (props: CalendarAppointmentProps) => {
  const { appointment, isHovered, onHover } = props;

  const onMouseOver = () => {
    onHover(appointment.id);
  };

  const onMouseOut = () => {
    onHover(null);
  };

  return <AppointmentSidePanel appointment={appointment}>
    <div onMouseOver={onMouseOver} onMouseOut={onMouseOut} className={classNames("calendar-appointment-wrapper", {
      "calendar-appointment-hovered": isHovered
    })}>
      {renderAppointmentBody(appointment)}
    </div>
  </AppointmentSidePanel>
};

interface ClickableCalendarAppointmentProps {
  appointment: server.dto.AppointmentForPlanner;
}

export const ClickableCalendarAppointment = (props: ClickableCalendarAppointmentProps) => {
  return <a className="calendar-appointment-wrapper calendar-appointment-link" href={props.appointment.detailUrl}>
    {renderAppointmentBody(props.appointment)}
  </a>
};